import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ApiService } from '../services/api.service';
import { catchError, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { NavigationService } from '../services/navigation.service';
import { AnalyticsService } from '../services/analytics.service';

export const notebookContentResolver: ResolveFn<any[]> = (route, state) => {
  const apiService = inject(ApiService);
  const navigationService = inject(NavigationService)
  const analyticsService = inject(AnalyticsService);

  return apiService.fetchNotebookContent().pipe(
    tap(() => {
      analyticsService.logEvent('notebook_view');
    }),
    catchError((error) => {
      navigationService.handleResolverError(error);
      return EMPTY;
    })
  );
};
